// extracted by mini-css-extract-plugin
export default {"page":"MyTutorsPage_page__qbuam","header":"MyTutorsPage_header__6SpQP"};